/**
 * Whether a click on a link should be handled by the SPA rather than the
 * browser.
 *
 * Modified clicks (⌘/Ctrl/Shift/Alt) and non-primary buttons fall through
 * untouched — intercepting those is the classic SPA bug that breaks
 * open-in-new-tab, and on a table of budgets "open three side by side to
 * compare them" is the normal way to use the thing.
 *
 * Its own module rather than a named export on `StatNavLink`: this is a pure
 * predicate, and keeping it out of the component file means a consumer (the
 * budget table's row links) can import it without pulling the design-system
 * `LinkText` into its module graph — which is also what lets a test stub the
 * component while still exercising the real guard.
 */
export const isPlainLeftClick = (event: {
  defaultPrevented: boolean
  button: number
  metaKey: boolean
  ctrlKey: boolean
  shiftKey: boolean
  altKey: boolean
}): boolean =>
  !event.defaultPrevented &&
  event.button === 0 &&
  !event.metaKey &&
  !event.ctrlKey &&
  !event.shiftKey &&
  !event.altKey
